import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtBtn from "./CustomTool/CtBtn";
import { Edit, Delete } from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { fetchPurchase } from "./API";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CtDtp from "./CustomTool/CtDtp";
import {
  get_30DaysBack_FromCurrentDate,
  get_YMD_from_SYS,
  validatedate_min_max,
  formatDateTime,
  getlocalstoragedate,
  setlocalstoragedate,
  setKeyboardShortcuts,
  getRowOfRT,
  csvFileName,
} from "../SystemUtility/SystemUtility";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import ResetDate from "../images/resetdate.png";
import CtART from "./CustomTool/ResponsiveTable";

class PurchaseList extends Component {
  state = {
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      { id: "dat_purchasedateDMY", label: "Date" },
      { id: "vac_supplier", label: "Supplier Name" },
      { id: "vac_billno", label: "Bill No" },
      { id: "dec_discamt", label: "Discount Amount" },
      { id: "dec_taxableamount", label: "Taxable" },
      { id: "dec_cgst", label: "CGST" },
      { id: "dec_sgst", label: "SGST" },
      { id: "dec_igst", label: "IGST" },
      { id: "dec_grandtotal", label: "Grand Total" },
      { id: "dec_advpay", label: "Adv. Payment" },
      { id: "dec_netpay", label: "Net Payment" },
      { id: "vac_transactiontype", label: "Transaction Type" },
      { id: "vac_remark", label: "Remark" },
      { id: "bint_acid", label: "bint_acid", hide: true },
      { id: "vac_company", label: "vac_company", hide: true },
      { id: "bint_purchaseno", label: "bint_purchaseno", hide: true },
      { id: "bint_vouno", label: "bint_vouno", hide: true },
      { id: "dat_purchasedate", label: "Date", hide: true },
    ],
    columnsdata: [
      { accessorKey: "dat_purchasedateDMY", header: "Date" },
      { accessorKey: "vac_supplier", header: "Supplier Name" },
      { accessorKey: "vac_billno", header: "Bill No" },
      { accessorKey: "dec_discamt", header: "Discount Amount" },
      { accessorKey: "dec_taxableamount", header: "Taxable" },
      { accessorKey: "dec_cgst", header: "CGST" },
      { accessorKey: "dec_sgst", header: "SGST" },
      { accessorKey: "dec_igst", header: "IGST" },
      { accessorKey: "dec_grandtotal", header: "Grand Total" },
      { accessorKey: "dec_advpay", header: "Adv. Payment" },
      { accessorKey: "dec_netpay", header: "Net Payment" },
      { accessorKey: "vac_transactiontype", header: "Transaction Type" },
      { accessorKey: "vac_remark", header: "Remark" },
      { accessorKey: "bint_acid", header: "bint_acid" },
      { accessorKey: "vac_company", header: "vac_company" },
      { accessorKey: "bint_purchaseno", header: "bint_purchaseno" },
      { accessorKey: "bint_vouno", header: "bint_vouno" },
      { accessorKey: "dat_purchasedate", header: "Date" },
    ],
    searchData: {
      dat_purchasedate: "",
      vac_supplier: "",
      vac_billno: "",
      vac_transactiontype: "",
      vac_remark: "",
    },
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "PurchaseList:",
        actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "PurchaseList:",
        actionType: "AlertResponsive",
        hide:
          this.props.userPrivilege.Purchase == "R" ||
          this.props.userPrivilege.Purchase == "W",
      },
    ],
    keyColumn: [
      "dat_purchasedate", //0
      "vac_supplier", //1
      "vac_billno", //2
      "dec_discamt", //3
      "dec_taxableamount", //4
      "dec_cgst", //5
      "dec_sgst", //6
      "dec_igst", //7
      "dec_grandtotal", //8
      "dec_advpay", //9
      "dec_roundoff", //10
      "dec_netpay", //11
      "vac_transactiontype", //12
      "vac_remark", //13
      "bint_acid", //14
      "vac_company", //15
      "bint_purchaseno", //16
      "bint_vouno", //17
    ],
    formData: {
      dtpFromDate: "",
      dtpToDate: "",
    },
    dataLoadStatus: true,
    ARD: null,
    rows: [],
    rowsCount: 0,
    rowsPerPage: 50,
    removeKeyboardShortCuts: null,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Purchase List";
    this.props.setActiveMenu("PurchaseList");
    this.setSearchColumns();
    this.ShortCut();
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "dtpFromDate" || e.target.name === "dtpToDate") {
          this.setfrom_todate();
        }
      }
    );
  };
  componentWillUnmount() {
    this.removeKeyboardShortCuts();
  }
  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };

  ShortCut = () => {
    this.setState({
      removeKeyboardShortCuts: setKeyboardShortcuts({
        handleOnclickAdd: this.handleOnNewEntryClick,
      }),
    });
  };
  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnSearchInputChange = (e) => {
    // console.log('handleOnSearchInputChange', [e.target.name], e.target.value, this.state.searchData);
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
        // console.log(this.state.searchData)
      }
    );
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.vac_supplier.length === 0 ||
            (row["vac_supplier"] &&
              row["vac_supplier"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_supplier.toLowerCase()))) &&
          (this.state.searchData.dat_purchasedate.length === 0 ||
            (row["dat_purchasedate"] &&
              row["dat_purchasedate"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.dat_purchasedate.toLowerCase()
                ))) &&
          (this.state.searchData.vac_billno.length === 0 ||
            (row["vac_billno"] &&
              row["vac_billno"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_billno.toLowerCase()))) &&
          (this.state.searchData.vac_transactiontype.length === 0 ||
            (row["vac_transactiontype"] &&
              row["vac_transactiontype"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_transactiontype.toLowerCase()
                ))) &&
          (this.state.searchData.vac_remark.length === 0 ||
            (row["vac_remark"] &&
              row["vac_remark"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_remark.toLowerCase())))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {}
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  NavigateToPurchase = (bint_acid, bint_purchaseno, bint_acyear) => {
    this.props.navigateTo("purchasenew", {
      bint_acid: bint_acid,
      bint_purchaseno: bint_purchaseno,
      bint_acyear: bint_acyear,
    });
  };

  handleARDonActionClick = (row) => {
    // console.log("values", values);
    const bint_acid = row.bint_acid,
      bint_purchaseno = row.bint_purchaseno,
      bint_acyear = localStorage.getItem("ACY"),
      actionName = row.actionName,
      vac_billno = row.vac_billno;
    if (actionName === "Edit") {
      // this.props.navigateTo(
      //   "purchasenew/:" +
      //     bint_acid +
      //     ":" +
      //     bint_purchaseno +
      //     ":" +
      //     bint_acyear
      // );
      this.NavigateToPurchase(bint_acid, bint_purchaseno, bint_acyear);
    } else if (actionName === "Delete") {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={"Do you want to Delete Bill No. : " + vac_billno + " ?"}
            alertMessage=""
            handleOnClickYes={() => {
              return this.deletePurchaseList(
                bint_acid,
                bint_purchaseno,
                bint_acyear
              );
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    }
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "bint_acid",
      "bint_purchaseno",
      "vac_billno",
    ]);

    const bint_acid = row.bint_acid,
      bint_purchaseno = row.bint_purchaseno,
      bint_acyear = localStorage.getItem("ACY"),
      vac_billno = row.vac_billno;
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelAgree="Delete"
          labelDisagree="Cancel"
          alertTitle={"Do you want to Delete Bill No. : " + vac_billno + " ?"}
          alertMessage=""
          handleOnClickYes={() => {
            return this.deletePurchaseList(
              bint_acid,
              bint_purchaseno,
              bint_acyear
            );
          }}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD });
    });
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_acid", "bint_purchaseno"]);

    const bint_acid = row.bint_acid,
      bint_purchaseno = row.bint_purchaseno,
      bint_acyear = localStorage.getItem("ACY");
    this.props.navigateTo("purchasenew", {
      bint_acid: bint_acid,
      bint_purchaseno: bint_purchaseno,
      bint_acyear: bint_acyear,
    });
  };

  handleOnNewEntryClick = () => {
    this.removeKeyboardShortCuts();
    this.props.navigateTo("purchasenew");
  };
  //#endregion handle

  //#region function

  setfrom_todate = (reset = false) => {
    setlocalstoragedate(
      "Purchase",
      this.state.formData.dtpFromDate,
      this.state.formData.dtpToDate,
      reset
    );
    if (reset) {
      window.location.reload();
      this.onFormLoad();
    }
  };

  onFormLoad = () => {
    const { fromdate, todate } = getlocalstoragedate("Purchase");
    let dtpFromDate = fromdate,
      dtpToDate = todate;
    // let dtpFromDate = get_30DaysBack_FromCurrentDate(),
    //   dtpToDate = get_YMD_from_SYS(new Date());
    this.setState(
      {
        formData: {
          ...this.state.formData,
          dtpFromDate,
          dtpToDate,
        },
      },
      () => {
        this.getInfo();
      }
    );
  };

  validateDate = () => {
    let result = false;
    const fromDate = this.state.formData.dtpFromDate;
    const toDate = this.state.formData.dtpToDate;

    if (this.state.formData.dtpFromDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpFromDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpFromDate,
        "dtpFromDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (this.state.formData.dtpToDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpToDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpToDate,
        "dtpToDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (new Date(fromDate) > new Date(toDate)) {
      this.props.toastErrorMsg(
        "To Date must be greater than From Date",
        "dtpFromDate"
      );
    } else {
      result = true;
    }
    return result;
  };

  getInfo = () => {
    if (this.validateDate()) {
      let dataLoadStatus = false;
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "PurchaseList",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          dat_fromdate: this.state.formData.dtpFromDate,
          dat_todate: this.state.formData.dtpToDate,
        };
        fetchPurchase(reqData)
          .then((res) => {
            dataLoadStatus = true;
            let rows = res.data.PurchaseList,
              rowsCount = rows.length;
            this.setState({
              dataLoadStatus,
              rows,
              rowsCount,
            });
          })
          .catch((error) => {
            console.log("Unknown error occurred in getInfo.", error);
          });
      });
    }
    document.getElementById("dtpFromDate").focus();
  };

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "dat_purchasedate",
        label: "Date",
        value: this.state.searchData.dat_purchasedate,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_supplier",
        label: "Supplier Name",
        value: this.state.searchData.vac_supplier,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "vac_billno",
        label: "Bill No",
        value: this.state.searchData.vac_billno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        label: "Discount Amt",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Taxable",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "CGST",
        width: "80",
      },
      {
        cType: "Lbl",
        label: "SGST",
        width: "80",
      },
      {
        cType: "Lbl",
        label: "IGST",
        width: "80",
      },
      {
        cType: "Lbl",
        label: "Grand Total",
        width: "80",
      },
      {
        cType: "Lbl",
        label: "Adv. Payment",
        width: "110",
      },
      {
        cType: "Lbl",
        label: "Net Amount",
        width: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_transactiontype",
        label: "Transaction Type",
        value: this.state.searchData.vac_transactiontype,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_remark",
        label: "Remark",
        value: this.state.searchData.vac_remark,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      }
    );
    this.setState({ searchColumns });
  };

  deletePurchaseList = (bint_acid, bint_purchasesrno, bint_acyear) => {
    let dataLoadStatus = false;
    this.props.notifyProcessing();
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "DeletePurchase",
        bint_acyear: bint_acyear,
        bint_acid: bint_acid,
        edit_purchaseno: bint_purchasesrno,
        dat_fromdate: this.state.formData.dtpFromDate,
        dat_todate: this.state.formData.dtpToDate,
      };
      fetchPurchase(reqData)
        .then((res) => {
          dataLoadStatus = true;
          this.props.updateProcessing(res.data.msgType, res.data.message);
          if (res.data.msgType === "success") {
            this.setState(
              {
                dataLoadStatus,
              },
              () => {
                this.getInfo();
              }
            );
          }
        })
        .catch((error) => {
          console.log("Unknown error occurred in deletePurchaseList.", error);
        });
    });
    return true;
  };
  //#endregion function

  render() {
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;

    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Purchase List</b>
          </label>
        </Grid> */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item style={{ display: "inline-flex" }}>
                <CardContent style={{ paddingBottom: "0px" }}>
                  <CardMedia
                    component="img"
                    alt="Reset Date to Default"
                    sx={{ width: 35 }}
                    image={ResetDate}
                    onClick={() => {
                      this.setfrom_todate(true);
                    }}
                  />
                </CardContent>
                <CtDtp
                  id="dtpFromDate"
                  label="From Date*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpFromDate}
                  value={this.state.formData.dtpFromDate}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID={"dtpToDate"}
                  accountYear={localStorage.getItem("ACY")}
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpToDate"
                  label="To Date*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpToDate}
                  value={this.state.formData.dtpToDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  defaultAction={this.getInfo}
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>
              <Grid item>
                <CtBtn label="Load" onClick={this.getInfo} variant="outlined" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        {/* <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          // provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          toolTipNewEntry="Purchase Entry"
        /> */}

        <CtART
          rowsdata={this.state.rows}
          columnsdata={this.state.columnsdata}
          rowsPerPage={this.state.rowsPerPage}
          tblmaxHeight={500}
          csvFileName={csvFileName("PurchaseList")}
          rowIconAction={[
            {
              label: "Edit",
              onClick: this.handleARDonActionClick_Edit,
              icon: "Edit",
              className: "secondary-button",
            },
            {
              label: "Delete",
              onClick: this.handleARDonActionClick_Delete,
              icon: "delete",
              className: "delete-button",
            },
            // this.props.userPrivilege["Entry:Proposal"] == "M"
            //   ? {
            //       label: "Delete",
            //       onClick: this.handleARDonActionClick_Delete,
            //       icon: "delete",
            //       className: "delete-button",
            //     }
            //   : "",
          ]}
          tableButtonAction={[
            {
              label: "Purchase Entry",
              onClick: this.handleOnNewEntryClick,
              addPluseIcon: true,
            },
            // this.props.userPrivilege["Entry:Proposal"] != "R"
            //   ? {
            //       label: "Add New Proposal",
            //       onClick: this.handleOnNewEntryClick,
            //       addPluseIcon: true,
            //     }
            //   : "",
          ]}
          showColumnFilters={false}
          actionColSize={90}
          hideColIdList={[
            "bint_acid",
            "vac_company",
            "bint_purchaseno",
            "bint_vouno",
            "dat_purchasedate",
          ]}
          density={"compact"}
        />
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(PurchaseList))));
